import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import rootReducer from './reducer';

export default (history, initialState = {}) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle

  const middleware = [thunk, routerMiddleware(history)];
  const enhancers = [];

  const enhancer = composeEnhancers(
    applyMiddleware(...middleware),
    // other store enhancers if any
    ...enhancers,
  );

  const store = createStore(
    rootReducer,
    initialState,
    enhancer,
  );

  const syncedHistory = syncHistoryWithStore(history, store);

  return {
    store,
    syncedHistory,
  };
};
